console.log("custom.js loaded");

// -- Cart Icon Pulse Animation -------------------------------------------------
// Injects CSS once, exposes window.aaPulseCartIcon() for use from any template.
(function () {
  var STYLE_ID = 'aa-cart-pulse-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@keyframes aa-cart-bounce {',
      '  0%   { transform: scale(1) rotate(0deg); }',
      '  25%  { transform: scale(1.4) rotate(-10deg); }',
      '  50%  { transform: scale(1.15) rotate(6deg); }',
      '  75%  { transform: scale(1.25) rotate(-4deg); }',
      '  100% { transform: scale(1) rotate(0deg); }',
      '}',
      '@keyframes aa-count-pop {',
      '  0%   { transform: scale(1); }',
      '  40%  { transform: scale(1.7); }',
      '  100% { transform: scale(1); }',
      '}',
      '.aa-cart-bounce { animation: aa-cart-bounce 0.5s cubic-bezier(.36,.07,.19,.97) both; }',
      '.aa-count-pop { animation: aa-count-pop 0.4s ease both; }',
      '.aa-count-highlight { background: #0EA5C9 !important; color: #fff !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function pulseCartIcon() {
    injectStyles();

    var icon = document.querySelector('.header__cart-icon');
    var count = document.querySelector('.header__cart-count');

    if (icon) {
      icon.classList.remove('aa-cart-bounce');
      void icon.offsetWidth; // force reflow to restart animation
      icon.classList.add('aa-cart-bounce');
      setTimeout(function () { icon.classList.remove('aa-cart-bounce'); }, 600);
    }

    if (count) {
      count.classList.remove('aa-count-pop', 'aa-count-highlight');
      void count.offsetWidth;
      count.classList.add('aa-count-pop', 'aa-count-highlight');
      setTimeout(function () {
        count.classList.remove('aa-count-pop', 'aa-count-highlight');
      }, 800);
    }
  }

  // Expose globally so collection table templates can call it
  window.aaPulseCartIcon = pulseCartIcon;

  // Trigger on product:added (fired by product page add-to-cart handler)
  document.addEventListener('product:added', function () {
    setTimeout(pulseCartIcon, 300);
  });
})();


// -- Powder-coat setup fee: ONE property shape for both add paths -------------
// Used by the product-page add handler below AND by the reconciler's
// addFeeVariant(), which previously wrote a different set. Visible rows so the
// customer can see what the $50 is for; "_setup_fee_for_colour" is the hidden
// marker aa-cart-guard.js identifies the line by. "_powder_fee_for_colour" is
// retained because surfaces outside this file (the four bar tables) write it and
// its readers have not been enumerated - retire it only after they have.
function powderFeeLineProps(colourName) {
  var colour = (colourName || "").toString().trim();
  var props = {
    "Setup Fee": "Powder Coating",
    "_setup_fee_for_colour": colour,
    "_powder_fee_for_colour": colour
  };
  if (colour) props["Colour"] = colour;
  return props;
}

function getPowderFeeMapForProduct() {
  const el = document.querySelector("script[data-powder-fee-map]");
  if (!el) return {};

  try {
    return JSON.parse(el.textContent) || {};
  } catch (error) {
    console.error("Could not parse powder fee map", error);
    return {};
  }
}

function getSelectedPowderTextFromForm(form) {
  if (!form) return "";

  const optionRows = form.querySelectorAll(".product-form__option");

  for (let i = 0; i < optionRows.length; i++) {
    const row = optionRows[i];
    const optionNameEl = row.querySelector(".product-form__option-name");
    const selectedValueEl = row.querySelector(".product-form__selected-value");

    const optionNameText = optionNameEl ? (optionNameEl.textContent || "") : "";
    const selectedValueText = selectedValueEl ? (selectedValueEl.textContent || "") : "";

    if (/(color|colour|finish)/i.test(optionNameText) && /powder[\s-]*coat/i.test(selectedValueText)) {
      return selectedValueText.trim();
    }
  }

  const selectedValueEls = form.querySelectorAll(".product-form__selected-value");
  for (let i = 0; i < selectedValueEls.length; i++) {
    const text = (selectedValueEls[i].textContent || "").trim();
    if (/powder[\s-]*coat/i.test(text)) {
      return text;
    }
  }

  const selects = form.querySelectorAll("select");
  for (let i = 0; i < selects.length; i++) {
    const select = selects[i];
    const selectedOption = select.options[select.selectedIndex];
    const optionText = selectedOption ? (selectedOption.textContent || "").trim() : "";

    if (/powder[\s-]*coat/i.test(optionText)) {
      return optionText;
    }
  }

  return "";
}

document.addEventListener(
  "click",
  async function (event) {
    const button = event.target.closest(".product-form__add-button");
    if (!button) return;

    const form = button.closest("form[action*='/cart/add']");
    if (!form) return;

    const section = button.closest("[data-section-type]");
    const sectionType = section ? section.getAttribute("data-section-type") : "";

    if (sectionType !== "product") return;

    event.preventDefault();
    event.stopImmediatePropagation();

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = "Adding...";

    try {
      const formData = new FormData(form);
      const variantId = formData.get("id");
      const quantity = Number(formData.get("quantity") || 1);

      const feeMap = getPowderFeeMapForProduct();

      const items = [
        {
          id: Number(variantId),
          quantity: quantity
        }
      ];

      const selectedText = getSelectedPowderTextFromForm(form);

      if (/powder[\s-]*coat/i.test(selectedText)) {
        const normalized = selectedText
          .replace(/powder[\s-]*coat/i, "")
          .toLowerCase()
          .replace(/[\s-]+/g, " ")
          .trim();

        const feeKey = Object.keys(feeMap).find(function (key) {
          return key.toLowerCase().trim() === normalized;
        });

        const feeId = feeKey ? feeMap[feeKey] : null;

        if (feeId) {
          // The MATERIAL line declares which setup-fee variant covers it, the same
          // way a cut line declares _cut_fee_qty / _cut_fee_variant. This matters at
          // checkout: the colour -> variant map is rendered only inside the product
          // form, never on /cart, so this declaration is the ONLY thing that can tell
          // aa-cart-guard.js the fee is owed once the customer is on the cart page.
          items[0].properties = Object.assign({}, items[0].properties, {
            "_setup_fee_variant": String(feeId),
            "_setup_fee_colour": feeKey
          });

          // r655 (26 Sep 2026): no setup fee once this colour reaches the coater's minimum. The rule lives in
          // aa-cart-guard.js (AACartGuard.pcSetupWaived); the declaration above is stamped either way, so the
          // guard puts the fee back if the order later drops under the minimum. No guard = the fee is added.
          let aaWaived = false;
          try {
            const aaG = window.AACartGuard;
            if (aaG && aaG.pcSetupWaived && aaG.pcAreaM2) {
              const aaSec = form.closest("[data-section-type]") || document;
              const aaTitleEl = aaSec.querySelector(".product-meta__title") || document.querySelector(".product-meta__title");
              let aaLenText = "";
              form.querySelectorAll(".product-form__option").forEach(function (r) {
                const n = r.querySelector(".product-form__option-name");
                const v = r.querySelector(".product-form__selected-value");
                if (n && v && /length/i.test(n.textContent || "")) aaLenText = v.textContent || "";
              });
              const aaRes = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
              const aaCart = await aaRes.json();
              aaWaived = aaG.pcSetupWaived(aaCart, feeId, aaG.pcAreaM2(aaTitleEl ? aaTitleEl.textContent : "", aaG.pcLengthM(aaLenText) || 6.5, quantity));
            }
          } catch (aaErr) { aaWaived = false; }
          if (!aaWaived) {
            items.push({
              id: Number(feeId),
              quantity: 1,
              properties: powderFeeLineProps(feeKey)
            });
          }
        }
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        const errText = await response.text();
        throw new Error(errText || "Could not add to cart");
      }
      // r776b: what was just added (variant | quantity) - the bar counts it once, in the cart, while the form still shows it.
      try { window.__aaPbAdded = String(Number(variantId)) + "|" + quantity; } catch (aaPbE) { /* display only */ }

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true
        })
      );

      button.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            button: button,
            quantity: quantity,
            productAdded: true
          }
        })
      );

      document.dispatchEvent(new CustomEvent("modal:close"));

      button.textContent = "Added";

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1000);
    } catch (err) {
      console.error("Product override add failed:", err);
      button.textContent = originalText;
      button.disabled = false;
    }
  },
  true
);

(function () {
  let powderFeeLock = false;

  function parseJsonScript(selector) {
    const el = document.querySelector(selector);
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error("Could not parse JSON from", selector, error);
      return null;
    }
  }

  function getFeeMap() {
    return parseJsonScript("script[data-powder-fee-map]") || {};
  }

  async function getCart() {
    const response = await fetch("/cart.js?_=" + Date.now(), {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache"
      }
    });

    if (!response.ok) {
      throw new Error("Could not load cart");
    }

    return response.json();
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      return Number(item.variant_id) === Number(variantId);
    });
  }

  function isPowderFeeItem(item) {
    const text = [
      item.product_title || "",
      item.title || "",
      item.variant_title || ""
    ].join(" ");

    return /powder[\s-]*coating[\s-]*setup[\s-]*fee/i.test(text);
  }

  function cartHasPowderColour(cart, colourName) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      if (isPowderFeeItem(item)) {
        return false;
      }

      const text = [
        item.product_title || "",
        item.title || "",
        item.variant_title || ""
      ].join(" ");

      if (!colourName) {
        return /powder[\s-]*coat/i.test(text);
      }

      const flat = function (s) { return String(s).toLowerCase().replace(/[\s-]+/g, " ").trim(); };
      if (flat(text).indexOf(flat(colourName + " Powder Coat")) !== -1) {
        return true;
      }

      const escapedColour = colourName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\s+/g, "[\\s-]+");
      const colourThenPowder = new RegExp(escapedColour + "[\\s-]*Powder[\\s-]*Coat", "i");
      const powderThenColour = new RegExp("Powder[\\s-]*Coat[\\s-]*" + escapedColour, "i");

      return colourThenPowder.test(text) || powderThenColour.test(text);
    });
  }

  // NOTE - deliberately does NOT back-fill _setup_fee_variant onto the material
  // line it is charging for. That line already exists in the cart, so stamping it
  // would mean a /cart/change.js carrying a properties object, and /cart/change.js
  // REPLACES a line's properties wholesale. On a cut line that set includes
  // _cut_fee_qty / _cut_fee_variant / Cut Map, so a dropped key here would silently
  // unguard the cutting charge and corrupt the workshop's cut data - a far bigger
  // loss than the $50 this is protecting. Material lines get stamped at ADD time
  // instead: the product handler above does it, and the four bar tables do it when
  // Lane B regenerates them. Carts added by any other path stay uncovered, and that
  // is the accepted limit of this rev.
  async function addFeeVariant(feeVariantId, colourName) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: Number(feeVariantId),
        quantity: 1,
        properties: powderFeeLineProps(colourName)
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error("Could not add powder coat setup fee: " + text);
    }

    return response.json();
  }

  // D-18: remove by line-item KEY, never by index. The cart object this reads was
  // fetched before the loop in syncPowderFees() started, and that loop can add or
  // remove lines before reaching this colour - so "line: index + 1" could point at
  // a line that has since moved and delete the WRONG one (a material line, with its
  // cut data). A key identifies one specific line no matter how the cart shifts,
  // which is what aa-cart-guard.js has always used.
  async function removeFeeVariantByLine(cart, feeVariantId) {
    const feeLine = (cart.items || []).find(function (item) {
      return Number(item.variant_id) === Number(feeVariantId);
    });

    if (!feeLine || !feeLine.key) return;

    const response = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: feeLine.key,
        quantity: 0
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error("Could not remove powder coat setup fee: " + text);
    }

    return response.json();
  }

  function refreshCartUi() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true
      })
    );
  }

  async function syncPowderFees() {
    if (powderFeeLock) return;

    const feeMap = getFeeMap();
    if (!feeMap || !Object.keys(feeMap).length) return;

    powderFeeLock = true;

    try {
      const cart = await getCart();
      let changed = false;

      for (const [colourName, feeVariantId] of Object.entries(feeMap)) {
        const hasPowderProduct = cartHasPowderColour(cart, colourName);
        const hasFee = cartHasVariant(cart, feeVariantId);

        // r655: the coater's minimum (aa-cart-guard.js) - never re-add a waived fee, and take one away.
        let waived = false;
        try { const aaG = window.AACartGuard; waived = !!(aaG && aaG.pcSetupWaived && aaG.pcSetupWaived(cart, feeVariantId)); } catch (e) { waived = false; }

        if (hasPowderProduct && !hasFee && !waived) {
          await addFeeVariant(feeVariantId, colourName);
          changed = true;
        }

        if ((!hasPowderProduct || waived) && hasFee) {
          await removeFeeVariantByLine(cart, feeVariantId);
          changed = true;
        }
      }

      if (changed) {
        refreshCartUi();
      }
    } catch (error) {
      console.error("Powder coat fee sync failed:", error);
    } finally {
      setTimeout(function () {
        powderFeeLock = false;
      }, 700);
    }
  }

  function queuePowderSync(delay) {
    setTimeout(function () {
      syncPowderFees();
    }, delay || 700);
  }

  document.addEventListener("click", function (event) {
    const cartAction = event.target.closest(
      ".mini-cart__quantity-remove, [data-action='decrease-quantity'], [data-action='increase-quantity'], #mini-cart-clear-button"
    );

    if (cartAction) {
      queuePowderSync(700);
    }
  });

  document.addEventListener("change", function (event) {
    const qtyInput = event.target.closest(".quantity-selector__value");

    if (qtyInput) {
      queuePowderSync(700);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    queuePowderSync(400);
  });

  document.documentElement.addEventListener("cart:refresh", function () {
    queuePowderSync(500);
  });

  document.addEventListener("product:added", function (event) {
    const button = event && event.detail && event.detail.button;
    const section = button && button.closest("[data-section-type]");
    const sectionType = section ? section.getAttribute("data-section-type") : "";

    if (sectionType === "product" || sectionType === "product-quick-view") {
      return;
    }

    queuePowderSync(800);
    queuePowderSync(1500);
  });
})();

(function () {
  function normaliseText(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .replace(/[\s-]+/g, " ")
      .trim();
  }

  function getPowderLeadtimeWrap() {
    return document.querySelector("[data-powder-leadtime-note]");
  }

  function getStandardPowderColours() {
    const wrap = getPowderLeadtimeWrap();
    if (!wrap) return [];

    const raw = wrap.getAttribute("data-standard-powder-colours") || "";

    return raw
      .split(/\r?\n|,/)
      .map(function (item) {
        return normaliseText(item);
      })
      .filter(Boolean);
  }

  function getSelectedFinishText() {
    const optionRows = document.querySelectorAll(".product-form__option");

    for (let i = 0; i < optionRows.length; i++) {
      const row = optionRows[i];
      const optionNameEl = row.querySelector(".product-form__option-name");
      const selectedValueEl = row.querySelector(".product-form__selected-value");

      const optionNameText = optionNameEl ? (optionNameEl.textContent || "") : "";
      const selectedValueText = selectedValueEl ? (selectedValueEl.textContent || "") : "";

      if (/(color|colour|finish)/i.test(optionNameText)) {
        return selectedValueText.trim();
      }
    }

    return "";
  }

  /* r656 (27 Sep 2026) - D149 + D150. The price EACH, setup included, as the customer changes the quantity; and an
     order of 80 m2 of one size in one colour told it is a mill run (allow 3-4 weeks, ask for a volume price).
     DISPLAY ONLY: nothing here adds, removes or prices a cart line. The numbers are the cart's own arithmetic -
     lengths x this variant's price, plus the colour's setup fee line unless the cart already holds it or
     aa-cart-guard.js waives it at the coater's minimum (the same pcSetupWaived the add path asks). Anything it cannot
     read (no guard, no product or fee price, a size it cannot parse) = no ladder: today's words exactly. */
  var AA_PE = { prod: null, fee: null, cart: null, busy: {} };
  var AA_PE_MILL_M2 = 80;
  function aaPeMoney(cents) {
    var p = (Math.round(Number(cents) || 0) / 100).toFixed(2).split(".");
    return "$" + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + p[1];
  }
  function aaPeLoad(key, url) {
    if (AA_PE[key] || AA_PE.busy[key]) return;
    AA_PE.busy[key] = true;
    fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { AA_PE.busy[key] = false; if (j) { AA_PE[key] = j; queuePowderLeadtimeUpdate(20); } })
      .catch(function () { AA_PE.busy[key] = false; });
  }

  /* r776 (7 Oct 2026) - THE FREE-SETUP BAR. Patryk ~10:40 pm: the price-each line is "too much information - that isn't our
     problem"; "a bar that shows it contribute to having a surcharge free". His ticks ~10:56 pm: as drawn, % and lengths.
     How close this colour is to a free setup = the colour's coated area already in the cart + this add, against the coater's
     minimum. EVERY number is asked of assets/aa-cart-guard.js (_pcColourAreaM2, PC_FREE_M2, pcSetupWaived - the rule the cart
     itself applies), so the bar and the charge cannot disagree: "free setup" is shown exactly when pcSetupWaived says so, and
     "N more lengths" is the smallest N for which pcSetupWaived says so. DISPLAY ONLY. Anything unreadable = no bar.
     r776b (8 Oct 2026) - his screenshot of three Woodland Grey rows on the angle table, 30/30/20, each bar on its own (75%,
     75%, 67%): "its not working towards the same colour free setup fee". Ticks: "Yes, count them", "Setup once, for all
     rows". Then: "i dont like how we are showing the price including setup fee" and "these are for custom powder coating
     colour... normal exstock doesnt cover it". So the bar also counts this colour's OTHER rows set up on the table
     (othersM2 - a third, lighter part); lengths just added are counted once, in the cart, never again as "these N"; and the
     setup is said by the bar ("the $50 setup in your cart comes off") so the price line under it is the lengths alone.
     Custom colours only, as before: a stocked colour has no setup fee, so no fee id, so no bar. */
  function aaPbState(G, cart, feeId, extraM2, perM2, othersM2) {
    var min = Number(G && G.PC_FREE_M2) || 0;
    if (!(min > 0) || !G._pcColourAreaM2 || !G.pcSetupWaived || !cart || !cart.items || !feeId) return null;
    var inCart = Number(G._pcColourAreaM2(cart, feeId)) || 0, add = Number(extraM2) || 0, oth = Number(othersM2) || 0;
    var reached = !!G.pcSetupWaived(cart, feeId, add + oth), alone = !!G.pcSetupWaived(cart, feeId, add), more = 0, m;
    if (!reached && perM2 > 0) {
      for (m = 1; m <= 5000; m++) { if (G.pcSetupWaived(cart, feeId, add + oth + m * perM2)) { more = m; break; } }
    }
    var feeIn = cart.items.some(function (it) { return Number(it.variant_id) === Number(feeId); });
    var pctCart = Math.min(100, inCart / min * 100), pctSelf = Math.min(100, (inCart + add) / min * 100),
      pctAll = Math.min(100, (inCart + add + oth) / min * 100);
    return { reached: reached, alone: alone, more: more, feeIn: feeIn, add: add, oth: oth,
      pctCart: pctCart, pctSelf: pctSelf, pctAll: pctAll, pct: reached ? 100 : Math.max(0, Math.min(99, Math.round(pctAll))) };
  }
  function aaPbEsc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function aaPbFee(cents) {
    var c = Math.round(Number(cents) || 0);
    return c % 100 === 0 ? "$" + (c / 100) : "$" + (c / 100).toFixed(2);
  }
  /* st from aaPbState; fee = the setup fee in cents; addLabel = this add's part ("these 10"); othLabel = the other rows' part.
     The parts, painted widest first: the other rows (lightest), this add, what is in the cart (darkest). */
  function aaPbHtml(colour, st, fee, addLabel, px, othLabel) {
    var fs = px || 13, C = aaPbEsc(colour), F = aaPbFee(fee), parts = [];
    if (st.reached) parts.push([100, "#1f8a4c", ""]);
    else {
      if (st.oth > 0 && st.pctAll > st.pctSelf) parts.push([st.pctAll, "#8fdbe8", othLabel || "your other rows"]);
      if (st.add > 0 && st.pctSelf > st.pctCart) parts.push([st.pctSelf, "#22b8cf", addLabel || "this add"]);
      if (st.pctCart > 0) parts.push([st.pctCart, "#0e7490", "in your cart"]);
    }
    var bar = "<div class=\"aa-pb-bar\" style=\"margin:7px 0 4px;height:10px;border-radius:5px;background:#e3e7ec;position:relative;overflow:hidden;\">" +
      parts.map(function (p) { return "<i style=\"position:absolute;left:0;top:0;bottom:0;width:" + p[0].toFixed(1) + "%;background:" + p[1] + ";\"></i>"; }).join("") + "</div>";
    var key = (!st.reached && parts.length > 1) ? "<div class=\"aa-pb-key\" style=\"font-size:" + (fs - 1.5) + "px;color:#64748b;margin-bottom:2px;\">" +
      parts.slice().reverse().map(function (p, i) {
        return "<span style=\"display:inline-block;width:9px;height:9px;border-radius:2px;background:" + p[1] + ";vertical-align:-1px;margin:" + (i ? "0 4px 0 8px" : "0 4px 0 0") + ";\"></span>" + aaPbEsc(p[2]);
      }).join(" ") + "</div>" : "";
    var words;
    if (st.reached && st.alone) words = "<b style=\"color:#1f8a4c;\">" + C + ": free setup</b> - this colour reaches the minimum" + (st.feeIn ? ", so the " + F + " setup in your cart comes off." : ".");
    else if (st.reached) words = "<b style=\"color:#1f8a4c;\">" + C + ": free setup once these rows are in your cart</b> - together they reach the minimum.";
    else words = "<b style=\"color:#0f172a;\">" + C + ": " + st.pct + "% of the way to free setup" + (st.oth > 0 ? "</b>, counting your other " + C + " rows. " : ".</b> ") +
      (st.more ? (st.more === 1 ? "1 more length" : st.more + " more lengths") + " of this size and the " + F + " comes off." : "Add more of this colour and the " + F + " comes off.");
    return "<div class=\"aa-pb\" style=\"font-size:" + fs + "px;line-height:1.45;\">" + bar + key + "<div class=\"aa-pb-words\">" + words + "</div></div>";
  }
  function aaPeRender(inner, feeNote) {
    const G = window.AACartGuard;
    if (!G || !G.pcAreaM2 || !G.pcFreeFromLengths || !G.pcSetupWaived || !G.pcLengthM) return;
    const form = document.querySelector("[data-section-type='product'] form[action*='/cart/add']");
    const hm = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!form || !hm) return;
    const fd = new FormData(form);
    const vid = Number(fd.get("id")), n = Math.max(1, parseInt(fd.get("quantity"), 10) || 1);
    const text = getSelectedPowderTextFromForm(form);
    if (!vid || !/powder[\s-]*coat/i.test(text)) return;
    const norm = text.replace(/powder[\s-]*coat/i, "").toLowerCase().replace(/[\s-]+/g, " ").trim();
    const map = getPowderFeeMapForProduct();
    const key = Object.keys(map).find(function (k) { return k.toLowerCase().trim() === norm; });
    const feeId = key ? Number(map[key]) : 0;
    if (!feeId) return;
    aaPeLoad("prod", "/products/" + hm[1] + ".js");
    aaPeLoad("fee", "/products/powder-coating-setup-fee.js");
    aaPeLoad("cart", "/cart.js");
    if (!AA_PE.prod || !AA_PE.fee) return;
    const v = (AA_PE.prod.variants || []).filter(function (x) { return Number(x.id) === vid; })[0];
    const fv = (AA_PE.fee.variants || []).filter(function (x) { return Number(x.id) === feeId; })[0];
    if (!v || !fv) return;
    const Pc = Number(v.price), Fc = Number(fv.price);
    const titleEl = document.querySelector(".product-meta__title");
    const title = titleEl ? titleEl.textContent : "";
    const lenM = G.pcLengthM(v.title) || 6.5;
    const a = G.pcAreaM2(title, lenM, 1), N = G.pcFreeFromLengths(title, lenM);
    if (!(Pc > 0) || !(Fc > 0) || !(a > 0) || !(N > 1)) return;
    // r776: no price-each ladder any more (Patryk ~10:40 pm 7 Oct: "too much information").
    // r776b: the setup line names its amount (it said "Setup fee applies" with no number; the table's line has always said
    // "Setup fee $50.00 applies"), now that the line under the price no longer carries the setup.
    Array.prototype.forEach.call(inner.childNodes, function (x) {
      if (x.nodeType === 3 && x.nodeValue.indexOf("Setup fee applies once per colour per order.") >= 0) {
        x.nodeValue = x.nodeValue.replace("Setup fee applies once per colour per order.", "Setup fee " + aaPeMoney(Fc) + " applies once per colour per order.");
      }
    });
    // r776b: the lengths alone (Patryk 8 Oct: "i dont like how we are showing the price including setup fee") - exactly what
    // this line will be in the cart. The $50 is its own line there; here the setup line and the bar say it.
    const yours = (n === 1 ? "Your 1 length: " : "Your " + n + " lengths: ") + aaPeMoney(n * Pc) + " ex GST.";
    let big = n * a >= AA_PE_MILL_M2 - 1e-9;
    const cart = AA_PE.cart;
    // r776: the bar - only once the cart has been read (a bar without the cart would be a guess). r776b: lengths just added
    // (this variant, this quantity, and the cart holds at least that many) are in the cart - counted there once, not again.
    let aaPbOut = "";
    if (cart && cart.items) {
      let same = 0;
      cart.items.forEach(function (it) { if (Number(it.variant_id) === vid) same += Number(it.quantity) || 0; });
      const done = window.__aaPbAdded === String(vid) + "|" + Number(fd.get("quantity") || 1) && same >= n;
      big = (same + (done ? 0 : n)) * a >= AA_PE_MILL_M2 - 1e-9;
      const st = aaPbState(G, cart, feeId, done ? 0 : n * a, a, 0);
      if (st) aaPbOut = aaPbHtml(key, st, Fc, n === 1 ? "this 1" : "these " + n, 13);
      /* r776c: the sticky add-to-cart bar said "+$50 setup fee" even when the setup is free - it reads this state now
         (sections/aa-sticky-atc.liquid), so it says what this bar says. Display only. */
      try {
        window.__aaPdpPc = st ? { vid: vid, reached: !!st.reached, pct: st.pct, feeIn: !!st.feeIn, fee: Fc } : null;
        document.dispatchEvent(new CustomEvent("aa:pdp-pcbar"));
      } catch (aaStErr) {}
    }
    const leadEl = inner.querySelector(".aa-pe-lead");
    if (big && leadEl) leadEl.textContent = "An order this size is made as a mill run: allow 3-4 weeks.";
    inner.insertAdjacentHTML("beforeend", aaPbOut + (big ? (aaPbOut ? "" : "<br>") + "<span class=\"aa-pe-big\">Ask us for a volume price: " +
      "<a href=\"tel:+61387250851\">(03) 8725 0851</a> or <a href=\"/pages/contact\">send us a message</a>.</span>" : ""));
    if (feeNote) {
      let y = feeNote.querySelector(".aa-pe-yours");
      if (!y) { y = document.createElement("div"); y.className = "aa-pe-yours"; y.style.marginTop = "4px"; feeNote.appendChild(y); }
      y.textContent = yours;
      y.style.display = yours ? "block" : "none";
    }
    return !!aaPbOut;
  }
  /* r776: the setup sentence once (his tick "Once, by the bar"). While the bar shows in the grey box, the note under the
     price keeps only "Your N lengths: ..." - its fixed sentence (the product form's own words) and the free-from words
     are hidden; with no bar, both show exactly as before. */
  function aaPbNoteBase(feeNote, show) {
    if (!feeNote) return;
    let base = feeNote.querySelector(".aa-pf-base");
    if (!base) {
      const tn = Array.prototype.filter.call(feeNote.childNodes, function (x) { return x.nodeType === 3 && x.nodeValue.trim(); })[0];
      if (!tn) return;
      base = document.createElement("span"); base.className = "aa-pf-base";
      feeNote.insertBefore(base, tn); base.appendChild(tn);
    }
    base.style.display = show ? "" : "none";
    const fr = feeNote.querySelector(".aa-powder-fee-free");
    if (fr) fr.style.display = show ? "" : "none";
  }

  function updatePowderLeadtimeMessage() {
    const wrap = getPowderLeadtimeWrap();
    if (!wrap) return;

    const inner = wrap.querySelector(".powder-coat-leadtime-note__inner");
    if (!inner) return;

    const selectedText = getSelectedFinishText();
    const selectedNormalised = normaliseText(selectedText);
    const standardColours = getStandardPowderColours();

    // Setup fee note - show only for custom PC
    const feeNote = document.querySelector(".aa-powder-fee-note");

    wrap.style.display = "none";
    inner.innerHTML = "";
    if (feeNote) feeNote.style.display = "none";

    if (!selectedNormalised) return;

    if (selectedNormalised.includes("mill")) {
      return;
    }

    if (selectedNormalised.includes("anod")) {
      inner.innerHTML =
        "<strong>Anodised finish selected</strong>" +
        "Available to order. Please allow approximately 1-3 business days.";
      wrap.style.display = "block";
      return;
    }

    const baseColour = selectedNormalised
      .replace(/powder[\s-]*coated?/gi, "")
      .replace(/\s+/g, " ")
      .trim();

    const isStandard =
      standardColours.indexOf(selectedNormalised) !== -1 ||
      standardColours.indexOf(baseColour) !== -1;

    if (isStandard) {
      inner.innerHTML =
        "<strong>Standard powder coat selected</strong>" +
        "Available to order. Please allow approximately 1-3 business days.";
    } else {
      // r655: say when the setup fee stops - the rule and the number come from aa-cart-guard.js; the page's own
      // title gives the size. No guard, or a title it cannot read = today's words exactly.
      let aaFreeTxt = "";
      try {
        const aaG = window.AACartGuard, aaH = document.querySelector(".product-meta__title");
        const aaN = (aaG && aaG.pcFreeFromLengths && aaH) ? aaG.pcFreeFromLengths(aaH.textContent, 6.5) : 0;
        if (aaN) aaFreeTxt = " Free from " + aaN + " lengths of this size. Mixed sizes in the same colour count too.";
      } catch (aaErr) { aaFreeTxt = ""; }
      inner.innerHTML =
        "<strong>Custom powder coated material selected</strong>" +
        "<span class=\"aa-pe-lead\">Lead time is approximately 2-3 weeks.</span><br>" +
        "Setup fee applies once per colour per order." + aaFreeTxt;
      if (feeNote) {
        feeNote.style.display = "block";
        let aaFreeEl = feeNote.querySelector(".aa-powder-fee-free");
        if (!aaFreeEl && aaFreeTxt) { aaFreeEl = document.createElement("span"); aaFreeEl.className = "aa-powder-fee-free"; feeNote.appendChild(aaFreeEl); }
        if (aaFreeEl) aaFreeEl.textContent = aaFreeTxt;
      }
      let aaPbShown = false;
      try { aaPbShown = !!aaPeRender(inner, feeNote); } catch (aaPeErr) { aaPbShown = false; /* display only - never block the page */ }
      try { aaPbNoteBase(feeNote, !aaPbShown); } catch (aaPbErr) { /* display only */ }
    }

    wrap.style.display = "block";
  }

  function queuePowderLeadtimeUpdate(delay) {
    setTimeout(function () {
      updatePowderLeadtimeMessage();
    }, delay || 50);
  }

  document.addEventListener("change", function () {
    queuePowderLeadtimeUpdate(50);
  });

  document.addEventListener("click", function () {
    queuePowderLeadtimeUpdate(50);
  });

  document.addEventListener("variant:changed", function () {
    queuePowderLeadtimeUpdate(50);
  });

  // r656: the price-each line follows the quantity as it is typed, and a cart change re-reads the cart.
  document.addEventListener("input", function (e) {
    const t = e.target;
    if (t && t.matches && t.matches("[name='quantity'], .quantity-selector__value")) queuePowderLeadtimeUpdate(50);
  });
  document.documentElement.addEventListener("cart:refresh", function () { AA_PE.cart = null; });

  document.addEventListener("DOMContentLoaded", function () {
    queuePowderLeadtimeUpdate(100);
  });

  window.addEventListener("load", function () {
    queuePowderLeadtimeUpdate(150);
  });

  document.documentElement.addEventListener("cart:refresh", function () {
    queuePowderLeadtimeUpdate(100);
  });
})();
// -- Mobile Search: Auto-focus on tap -----------------------------------------
// On mobile, tapping the search icon only opens the inline bar (is-visible).
// The customer then has to tap the tiny input to get the full overlay (is-fixed).
// This skips that step - tapping the icon goes straight to the full overlay.
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-action="toggle-search"]')) return;
    if (window.innerWidth > 767) return;
    setTimeout(function () {
      var input = document.querySelector('.search-bar__input');
      if (input) input.focus();
    }, 30);
  });
})();


// -- Cut-to-size acknowledgement (collection table cut tools) -----------------
// The collection-table section files (main-collection-*-table, collection-table-sheets)
// are ~170KB each and can't be edited surgically through the theme API, so the required
// disclaimer tick is injected and enforced here. Matches the PDP modal behaviour.
(function () {
  var BTN_SEL = '.aa-cut-add-cart, .aa-cut-add-cart-btn';
  /* GOALS.md 3c.3, ruled by Patryk 2 Aug. TWO wordings, chosen by the surface.
     ± and — are written as escapes on purpose: this file is pasted by hand and a
     literal multi-byte character has mojibaked before (HANDOVER 5). */
  /* r-slim 21 Aug 2026, Patryk's call: three stacked blocks of small print sat between
     the estimate and the Add button, saying sharp-edges twice and no-refunds twice.
     The tick keeps what the customer must ACCEPT (measurements, no refund, \u00b12mm -
     and on 2D, the bow clause: under-warning is the worse error, GOALS 4.2). The
     sharp-edges fact and the refund-policy link move to ONE quiet line below the tick
     - see injectAck. Every fact is still on the panel, said once.
     THE GATE MATCHES BY TEXT (aa-cut-consent CONSENT_RE): both wordings must keep the
     phrases "checked my measurements" and "returned or refunded". They do. */
  var ACK_1D = 'I\'ve checked my measurements \u2014 cut-to-order items can\'t be returned or refunded if my sizes are wrong, and I accept the \u00b12mm cutting tolerance.';
  var ACK_2D = 'I\'ve checked my measurements \u2014 cut-to-order items can\'t be returned or refunded if my sizes are wrong. I accept the \u00b12mm cutting tolerance, and that narrow or thin strips can bow slightly as the metal\'s stress releases \u2014 not a fault.';

  /* The kind is a property of the SURFACE, declared once on the panel root as
     data-cut-kind. It is NOT inferred from the product, the button class or anything
     absent: an absent signal is not a value, it is UNKNOWN, and unknown takes the
     protective branch - here the 2D superset, which carries the bow clause as well as
     edges. Under-warning is the worse error (GOALS 4.2). */
  function ackTextFor(btn) {
    var root = btn && btn.closest ? btn.closest('[data-cut-kind]') : null;
    var kind = root ? String(root.getAttribute('data-cut-kind') || '').toLowerCase() : '';
    return kind === 'linear' ? ACK_1D : ACK_2D;
  }

  function injectAck(btn) {
    if (!btn || btn._aaAck) return btn && btn._aaAck;
    /* r-bigtick 21 Aug 2026, Patryk: "we have old people and people with no
       computer/phone skill". The tick was a 14px box with 11px grey text - it read as
       small print, not as a control the customer must operate, and the store's own rule
       everywhere else is a 44px minimum tap target. Now it is a bordered CARD (the whole
       card is the label, so the whole card is the hit area), a 22px box, 13px text, and
       the card turns cyan-tinted with a coloured border the moment it is ticked - so
       "done" is visible at arm's length. Same checkbox, same gate, same wording. */
    var label = document.createElement('label');
    label.className = 'aa-cut-ack';
    label.style.cssText = 'display:flex; align-items:flex-start; gap:12px; font-size:13px; color:#334155; line-height:1.5; margin-bottom:10px; cursor:pointer; background:#fff; border:2px solid #cbd5e1; border-radius:10px; padding:14px; min-height:44px; box-sizing:border-box;';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'aa-cut-ackbox';
    cb.style.cssText = 'width:22px; height:22px; flex-shrink:0; margin-top:0; accent-color:#12b8e5; cursor:pointer;';
    var span = document.createElement('span');
    span.textContent = ackTextFor(btn);
    label.appendChild(cb);
    label.appendChild(span);
    cb.addEventListener('change', function () {
      label.style.borderColor = cb.checked ? '#12b8e5' : '#cbd5e1';
      label.style.background  = cb.checked ? '#f0fbfe' : '#fff';
    });
    /* Stamp SYNCHRONOUSLY, in the same function that builds the label, so aa-cut-consent's
       400ms shortenCopy() poll leaves this per-kind wording alone. setInterval cannot
       interleave with a synchronous function, so there is no race - but stamping from a
       timeout or a second pass WOULD create one. Do not move this. */
    label.setAttribute('data-aa-shortened', '1');
    if (btn.parentNode) btn.parentNode.insertBefore(label, btn);
    /* r-slim: the orange edge-note and the grey policy line merged into ONE quiet line.
       The sharp-edges / bare-ends fact left the tick wording above, so this line is now
       its only home on the panel - do not delete it without putting the fact back. */
    var link = document.createElement('div');
    link.className = 'aa-cut-acklink';
    link.style.cssText = 'font-size:10.5px; color:#94a3b8; line-height:1.4; margin-bottom:9px;';
    link.innerHTML = 'Freshly cut edges can be sharp \u2014 coated or anodised ends show bare aluminium. Made-to-order: see our <a href="/policies/refund-policy" target="_blank" rel="noopener" style="color:#0b7fa0; text-decoration:underline;">refund policy</a>.';
    if (btn.parentNode) btn.parentNode.insertBefore(link, btn);
    btn._aaAck = cb;
    return cb;
  }

  function injectIn(root) {
    var list = (root || document).querySelectorAll(BTN_SEL);
    for (var i = 0; i < list.length; i++) injectAck(list[i]);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(BTN_SEL) : null;
    if (!btn) return;
    var cb = btn._aaAck || injectAck(btn);
    if (cb && !cb.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var msg = btn.parentNode && btn.parentNode.querySelector('.aa-cut-message');
      if (msg) {
        msg.style.display = 'block';
        msg.style.color = '#b45309';
        msg.textContent = 'Please tick the box to confirm before adding to cart.';
      }
      try { cb.focus(); } catch (err) {}
    }
  }, true);

  function init() { injectIn(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(BTN_SEL)) injectAck(node);
          if (node.querySelectorAll) injectIn(node);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (err) {}
})();
;
/* r776c (8 Oct 2026) - ON EVERY PAGE NOW: the same empty div is left by snippets/mini-cart.liquid (the mini cart, on every
   page) and sections/aa-delivery-quote.liquid (What we're quoting), so the filler no longer stops off the cart page. Patryk:
   "we need it to be for the whole website". It does nothing until an empty .aa-pcbar is on the page (no fetch).
   r776 (7 Oct 2026) - THE FREE-SETUP BAR ON THE CART PAGE. sections/main-cart.liquid leaves an empty
   <div class="aa-pcbar" data-fee-variant="..."> under "Applied automatically once per colour" on each powder coat setup fee
   line; this fills it: how close that colour is to a free setup, from the cart's own lines - every number asked of
   assets/aa-cart-guard.js (the rule the cart applies; it removes the fee line itself once the colour reaches the minimum).
   The cart section re-renders on a quantity change and replaces the div, so this looks again every 700 ms and fills any
   empty one from a fresh /cart.js. DISPLAY ONLY. No guard, or anything unreadable = the div stays empty (today's cart). */
(function () {
  var busy = false;
  function aaPbState(G, cart, feeId, extraM2, perM2) {
    var min = Number(G && G.PC_FREE_M2) || 0;
    if (!(min > 0) || !G._pcColourAreaM2 || !G.pcSetupWaived || !cart || !cart.items || !feeId) return null;
    var inCart = Number(G._pcColourAreaM2(cart, feeId)) || 0, add = Number(extraM2) || 0;
    var reached = !!G.pcSetupWaived(cart, feeId, add), more = 0, m;
    if (!reached && perM2 > 0) {
      for (m = 1; m <= 5000; m++) { if (G.pcSetupWaived(cart, feeId, add + m * perM2)) { more = m; break; } }
    }
    var pctAll = Math.min(100, (inCart + add) / min * 100);
    return { reached: reached, more: more, pctAll: pctAll, pct: reached ? 100 : Math.max(0, Math.min(99, Math.round(pctAll))) };
  }
  function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function fee$(cents) { var c = Math.round(Number(cents) || 0); return c % 100 === 0 ? "$" + (c / 100) : "$" + (c / 100).toFixed(2); }
  function sizeOf(title) {
    var n = [], re = /(\d+(?:\.\d+)?)\s*mm\b/gi, m;
    while ((m = re.exec(String(title || ""))) !== null) n.push(m[1]);
    return n.length >= 2 ? n.join(" x ") : "";
  }
  function fill(cart) {
    var G = window.AACartGuard;
    if (!G || !G._pcColourAreaM2 || !G.pcSetupWaived || !G.pcAreaM2 || !G.pcLengthM) return;
    var items = (cart && cart.items) || [];
    Array.prototype.forEach.call(document.querySelectorAll(".aa-pcbar[data-fee-variant]:not([data-aa-done])"), function (el) {
      el.setAttribute("data-aa-done", "1");
      var feeId = Number(el.getAttribute("data-fee-variant"));
      var feeLine = items.filter(function (it) { return Number(it.variant_id) === feeId; })[0];
      if (!feeId || !feeLine) return;
      var p = feeLine.properties || {};
      var colour = String(p["Colour"] || p["_setup_fee_for_colour"] || p["_powder_fee_for_colour"] || "").trim() || "This colour";
      // The size the customer has most lengths of in this colour - the "N more lengths of ..." is counted in it.
      var best = null;
      items.forEach(function (it) {
        if (Number((it.properties || {})["_setup_fee_variant"]) !== feeId) return;
        var per = G.pcAreaM2(it.product_title, G.pcLengthM(it.variant_title), 1);
        if (per > 0 && (!best || Number(it.quantity) > Number(best.it.quantity))) best = { it: it, per: per };
      });
      var st = aaPbState(G, cart, feeId, 0, best ? best.per : 0);
      if (!st) return;
      var size = best ? sizeOf(best.it.product_title) : "";
      var tail = (st.more && size)
        ? "About " + (st.more === 1 ? "1 more length" : st.more + " more lengths") + " of " + esc(size) + " (or any " + esc(colour) + " angle or channel) and this " + fee$(feeLine.final_line_price || feeLine.price) + " comes off."
        : "Add more " + esc(colour) + " angle or channel and this " + fee$(feeLine.final_line_price || feeLine.price) + " comes off.";
      var all = st.reached ? 100 : st.pctAll;
      el.innerHTML = "<div class=\"aa-pb\" style=\"font-size:13px;line-height:1.45;margin-top:6px;max-width:420px;\">" +
        "<div class=\"aa-pb-bar\" style=\"margin:4px 0 4px;height:10px;border-radius:5px;background:#e3e7ec;position:relative;overflow:hidden;\">" +
        "<i style=\"position:absolute;left:0;top:0;bottom:0;width:" + all.toFixed(1) + "%;background:" + (st.reached ? "#1f8a4c" : "#0e7490") + ";\"></i></div>" +
        "<div class=\"aa-pb-words\">" + (st.reached
          ? "<b style=\"color:#1f8a4c;\">" + esc(colour) + ": free setup</b> - this colour reaches the minimum, so this " + fee$(feeLine.final_line_price || feeLine.price) + " comes off."
          : "<b style=\"color:#0f172a;\">" + esc(colour) + ": " + st.pct + "% of the way to free setup.</b> " + tail) + "</div></div>";
    });
  }
  function tick() {
    if (busy || !window.AACartGuard || !document.querySelector(".aa-pcbar[data-fee-variant]:not([data-aa-done])")) return;
    busy = true;
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { busy = false; if (c) { try { fill(c); } catch (e) {} } })
      .catch(function () { busy = false; });
  }
  setInterval(tick, 700);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tick); else tick();
})();
